import React from "react";
import "./styles.scss";

const loadNativendo = () => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    const currentPath = location.href.startsWith("https://www.t-online")
        ? location.href
        : "https://www.t-online.de/finanzen/boerse/";
    s.src = "//d.nativendo.de/cds/delivery/init?url=" + currentPath;
    document.getElementsByTagName("head")[0].appendChild(s);
};

if (typeof window !== "undefined") {
    loadNativendo();
}

export const TopPartner = () => {
    return (
        <ul className="topPartner">
            <li>
                <div id="6618120sa"></div>
            </li>
            <li>
                <div id="6618121sa"></div>
            </li>
            <li>
                <div id="6618122sa"></div>
            </li>
            <li>
                <div id="6618123sa"></div>
            </li>
            <li>
                <div id="6618124sa"></div>
            </li>
        </ul>
    );
};
